/*!
 * pStrength jQuery Plugin v1.0.6
 * http://accountspassword.com/pstrength-jquery-plugin
 *
 * @see OLM: Módosítva, hogy a div.strength-en belüli span színét változtassa + alapszínek módosítva
 *
 * Created by AccountsPassword.com
 * Released under the GPL General Public License (Feel free to copy, modify or redistribute this plugin.)
 *
 */

(function ($) {
    var numbers_array = new Array(),
        upper_letters_array = new Array(),
        lower_letters_array = new Array(),
        special_chars_array = new Array(),
        pStrengthElementsDefaultStyle = new Array(),
        settings,
        pStrengthChanger = $('div.strength span');
    methods = {
        init: function (options, callbacks) {
            settings = $.extend(
                {
                    bind: 'keyup change',
                    changeBackground: true,
                    backgrounds: [
                        ['#cc0000', '#FFF'],
                        ['#cc3333', '#FFF'],
                        ['#cc6666', '#FFF'],
                        ['#ff9999', '#FFF'],
                        ['#e0941c', '#FFF'],
                        ['#e8a53a', '#FFF'],
                        ['#eab259', '#FFF'],
                        ['#efd09e', '#FFF'],
                        ['#ccffcc', '#FFF'],
                        ['#66cc66', '#FFF'],
                        ['#33cc33', '#FFF'],
                        ['#00cc00', '#FFF'],
                        ['#00cc00', '#FFF'],
                    ],
                    passwordValidFrom: 60, // 60%
                    onValidatePassword: function (percentage) {},
                    onPasswordStrengthChanged: function (
                        passwordStrength,
                        percentage,
                    ) {},
                },
                options,
            );

            for (var i = 48; i < 58; i++) numbers_array.push(i);
            for (i = 65; i < 91; i++) upper_letters_array.push(i);
            for (i = 97; i < 123; i++) lower_letters_array.push(i);
            for (i = 33; i < 48; i++) special_chars_array.push(i);
            for (i = 58; i < 65; i++) special_chars_array.push(i);
            for (i = 91; i < 97; i++) special_chars_array.push(i);
            for (i = 123; i < 127; i++) special_chars_array.push(i);

            return this.each(
                $.proxy(function (idx, pStrengthElement) {
                    pStrengthElementsDefaultStyle[$(pStrengthElement)] = {
                        background: $(pStrengthElement).css('background'),
                        color: $(pStrengthElement).css('color'),
                    };

                    calculatePasswordStrength.call(pStrengthElement);

                    $(pStrengthElement).on(settings.bind, function () {
                        calculatePasswordStrength.call(pStrengthElement);
                    });
                }, this),
            );

            return this;
        },

        changeBackground: function (pStrengthElement, passwordStrength) {
            if (passwordStrength === undefined) {
                passwordStrength = pStrengthElement;
                pStrengthElement = $(this);
            }
            passwordStrength = passwordStrength > 12 ? 12 : passwordStrength;

            $(pStrengthChanger).css({
                'background-color': settings.backgrounds[passwordStrength][0],
                color: settings.backgrounds[passwordStrength][1],
            });
        },

        resetStyle: function (pStrengthChanger) {
            $(pStrengthChanger).css(
                pStrengthElementsDefaultStyle[$(pStrengthChanger)],
            );
        },
    };

    var ord = function (string) {
        var str = string + '',
            code = str.charCodeAt(0);
        if (0xd800 <= code && code <= 0xdbff) {
            var hi = code;
            if (str.length === 1) {
                return code;
            }
            var low = str.charCodeAt(1);
            return (hi - 0xd800) * 0x400 + (low - 0xdc00) + 0x10000;
        }

        if (0xdc00 <= code && code <= 0xdfff) {
            return code;
        }
        return code;
    };

    var calculatePasswordStrength = function () {
        var passwordStrength = 0,
            numbers_found = 0,
            upper_letters_found = 0,
            lower_letters_found = 0,
            special_chars_found = 0,
            text = $(this).val();

        for (var i = 0; i < text.length; i++) {
            if ($.inArray(ord(text.charAt(i)), numbers_array) != -1) {
                numbers_found++;
                continue;
            }
            if ($.inArray(ord(text.charAt(i)), upper_letters_array) != -1) {
                upper_letters_found++;
                continue;
            }
            if ($.inArray(ord(text.charAt(i)), lower_letters_array) != -1) {
                lower_letters_found++;
                continue;
            }
            if ($.inArray(ord(text.charAt(i)), special_chars_array) != -1) {
                special_chars_found++;
                continue;
            }
        }

        if (text.length < 6) {
            passwordStrength = Math.min(
                Math.min(lower_letters_found, 2) +
                    Math.min(upper_letters_found, 2) +
                    Math.min(special_chars_found, 3) +
                    Math.min(numbers_found, 3),
                3,
            );
        } else if (
            upper_letters_found + special_chars_found > 0 &&
            lower_letters_found > 0 &&
            numbers_found > 0
        ) {
            passwordStrength = Math.min(
                Math.min(lower_letters_found, 2) +
                    Math.min(upper_letters_found, 2) +
                    Math.min(special_chars_found, 2) +
                    Math.min(numbers_found, 2) +
                    Math.min(2 * Math.floor(text.length / 6), 4),
                12,
            );
        } else {
            passwordStrength = Math.min(
                Math.min(lower_letters_found, 2) +
                    Math.min(upper_letters_found, 2) +
                    Math.min(special_chars_found, 2) +
                    Math.min(numbers_found, 2) +
                    Math.min(2 * Math.floor(text.length / 6), 2),
                4,
            );
        }
        behaviour.call($(this), passwordStrength);

        return passwordStrength;
    };

    var behaviour = function (passwordStrength) {
        var strengthPercentage = Math.ceil((passwordStrength * 100) / 12);
        strengthPercentage =
            strengthPercentage > 100 ? 100 : strengthPercentage;

        settings.onPasswordStrengthChanged.call(
            $(this),
            passwordStrength,
            strengthPercentage,
        );
        if (strengthPercentage >= settings.passwordValidFrom) {
            settings.onValidatePassword.call($(this), strengthPercentage);
        }

        if (settings.changeBackground) {
            methods.changeBackground.call(pStrengthChanger, passwordStrength);
        }
    };

    $.fn.pStrength = function (method) {
        if (methods[method]) {
            return methods[method].apply(
                this,
                Array.prototype.slice.call(arguments, 1),
            );
        } else if (typeof method === 'object' || !method) {
            return methods.init.apply(this, arguments);
        } else {
            console.error(
                'Method ' + method + ' does not exists on jQuery.pStrength',
            );
        }
    };
})(jQuery);
